export enum UserPlatform {
    ER = 'er',
    EM = 'em',
    OPS = 'ops',
}

export enum DevicePlatformType {
    MOBILE = 'mobile',
    WEB = 'web',
}
